import React, { useRef, useState } from 'react';
import { hrefForSameSiteAsset } from '../productMediaUtils';
import { CUSTOMER_PHOTO_ACCEPT, uploadCustomerPhotoFile } from './customerPhotoUpload';

/**
 * Customer photo upload for locket / bespoke jewelry (public API, not admin).
 */
export default function ProductPhotoUpload({
  id = 'jewelry-photo',
  label = 'Upload photo',
  hint = '',
  value = '',
  onChange,
  disabled = false,
  required = false,
}) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const onPick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    setError('');
    setBusy(true);
    try {
      const result = await uploadCustomerPhotoFile(file);
      if (!result.ok) {
        setError(result.error);
        return;
      }
      onChange?.(result.url);
    } finally {
      setBusy(false);
    }
  };

  const preview = value ? hrefForSameSiteAsset(value) : '';

  return (
    <div className="jewelry-photo-upload">
      <label className="jewelry-customizer__label" htmlFor={id}>
        {label}
        {required ? <span className="jewelry-customizer__req"> *</span> : null}
      </label>
      {hint ? <p className="jewelry-customizer__hint small text-muted mb-2">{hint}</p> : null}
      <div className="jewelry-photo-upload__row">
        {preview ? (
          <div className="jewelry-photo-upload__preview">
            <img src={preview} alt="Your upload preview" />
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary jewelry-photo-upload__change"
              disabled={disabled || busy}
              onClick={() => inputRef.current?.click()}
            >
              Change photo
            </button>
          </div>
        ) : (
          <button
            type="button"
            className="btn btn-outline-primary btn-sm jewelry-photo-upload__pick"
            disabled={disabled || busy}
            onClick={() => inputRef.current?.click()}
          >
            {busy ? 'Uploading…' : 'Choose photo'}
          </button>
        )}
        <input
          ref={inputRef}
          id={id}
          type="file"
          accept={CUSTOMER_PHOTO_ACCEPT}
          className="visually-hidden"
          disabled={disabled || busy}
          onChange={onPick}
        />
      </div>
      {error ? (
        <p className="jewelry-customizer__error small mb-0" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
